import { FunctionComponent, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Autocomplete, { KeyValue } from '@components/Autocomplete/Autocomplete'
import API from '@api/client'

import { BookProps } from '../AnswerProps'
import { MimeType, pixelateImage } from '@helpers/pixelate'
import Image from '@components/Image/Image'
import defaultBookImage from './no-movie.jpg'
import defaultBookImageWebp from './no-movie.webp'
import defaultBookImageAvif from './no-movie.avif'
import './BookInput.scss'
import { Book } from '@models/Book'

export const BookInput: FunctionComponent<BookProps> = ({ onSelection, answer }: BookProps) => {
  const { t } = useTranslation('Book')

  const [booksList, setBooksList] = useState<Book[]>([])

  const getDefaultItemFromAnswer = useCallback((): KeyValue | undefined => {
    if (!answer) return

    const { id: value, title: label } = answer
    return {
      value,
      label,
    }
  }, [answer])
  const onSearchBooks = async (title: string) => {
    const res = await API.searchBooks(title)
    setBooksList(res.data.data)
  }

  const onSelectChange = async (item: KeyValue) => {
    const book = booksList.find((book) => book.id === parseInt(item.value))
    if (!book) {
      return
    }
    onSelection({
      id: book.id.toString(),
      isbn: book.isbn.toString(),
      title: book.name,
      thumbnailUrl: book?.image.thumbnail,
      pixelatedThumbnailUrl: await pixelateImage(book?.image.thumbnail, MimeType.PNG, 10),
    })
  }
  const BookArtwork = useCallback(() => {
    if (answer?.thumbnailUrl) {
      return <Image src={answer?.thumbnailUrl} />
    }

    return <Image src={defaultBookImage} srcWebp={defaultBookImageWebp} srcAvif={defaultBookImageAvif} />
  }, [answer?.thumbnailUrl])

  return (
    <div className="BookInput">
      <div className="inputs">
        <Autocomplete
          placeholder={t('book')}
          items={booksList.map((book) => ({
            label: book.name,
            value: book.id.toString(),
          }))}
          defaultSelectedItem={getDefaultItemFromAnswer()}
          onInputChange={onSearchBooks}
          onSelectChange={onSelectChange}
        />
      </div>
      <div className="centered-content">
        <BookArtwork />
      </div>
    </div>
  )
}

export default BookInput
